var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _feBlend, _feBlend2, _mask, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _feBlend3, _feBlend4, _mask2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _feBlend5, _feBlend6, _mask3, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPepper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 381.6 381.6",
    style: {
      enableBackground: "new 0 0 381.6 381.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A5E00;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#3A5F03;}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:#E4FF83;}\n\t.st6{fill:url(#SVGID_4_);}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st10{mask:url(#SVGID_6_);fill:url(#SVGID_7_);}\n\t.st11{fill:url(#SVGID_8_);}\n\t.st12{fill:url(#SVGID_9_);}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st15{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st16{mask:url(#SVGID_11_);fill:url(#SVGID_12_);}\n\t.st17{fill:url(#SVGID_13_);}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{fill:url(#SVGID_15_);}\n\t.st20{filter:url(#Adobe_OpacityMaskFilter_4_);}\n\t.st21{filter:url(#Adobe_OpacityMaskFilter_5_);}\n\t.st22{mask:url(#SVGID_16_);fill:url(#SVGID_17_);}\n\t.st23{fill:url(#SVGID_18_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "pepper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.9,194.1c3.9-3.6,5.5-8.8,4.9-14c-0.3-2.9-1.3-5.6-2.7-8.1c-1-1.8-2.3-3.3,0.2-4.8 c1.1-0.7,2-1.5,2.8-2.6c3.1-4.4,4.3-10.2,2.7-15.3c-0.8-2.7-1.7-5.6-3.8-7.7c-2-2-4.7-3.2-7.4-4c-2.7-0.8-5.9-1.9-8.7-0.8 c-1.6,0.6-3,1.7-4.4,2.7c-1.6,1.1-3.3,2.2-4.9,3.3c-0.6-1.8-1.7-3.1-3-4.3c1.9,3.2,2.9,5.8,2.4,6.9l-1.6,3.1 c3.5-2.3,8.5-5.1,12.6-5.7c4.4-0.6,7.5-0.4,11.2,2.5c4.2,3.3,4.9,7.4,2.3,13.3c-1.9,4.1-5.2,8.1-9.1,10.2 c2.8,3.9,4.1,8.3,5.3,12.4c1.1,4,1.9,8.2,0.7,12.3C119.3,193.9,119.6,194.4,119.9,194.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.9124,
    y1: 169.5051,
    x2: 125.551,
    y2: 169.5051,
    gradientTransform: "matrix(0.3182 0.948 -0.948 0.3182 225.8906 26.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A5F03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1943,
    style: {
      stopColor: "#415610"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7072,
    style: {
      stopColor: "#50402D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#563838"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.6,138.5c-0.8-0.7-1.7-1.3-2.6-1.9c-2.3-1.5-4.7-3-7.4-3.9c-4.1-1.4-9.4-0.9-11.6,3.4 c-0.5,0.2-0.9,0.5-1.3,0.8c-0.2,0.1,0,0.4,0.2,0.3c0.3-0.2,0.7-0.3,1-0.5c0.1,0.2,0.4,0.2,0.6,0c0-0.1,0.1-0.2,0.1-0.2 c3.9-1.3,8.3-0.5,11.8,1.7c3.7,2.3,8.5,7.6,9.8,10.5c0,0,0.1,0,0.1,0l1.6-3.1C98.6,144.3,97.6,141.7,95.6,138.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.6,138.5c-0.8-0.7-1.7-1.3-2.6-1.9c-2.3-1.5-4.7-3-7.4-3.9c-4.1-1.4-9.4-0.9-11.6,3.4 c-0.5,0.2-0.9,0.5-1.3,0.8c-0.2,0.1,0,0.4,0.2,0.3c0.3-0.2,0.7-0.3,1-0.5c0.1,0.2,0.4,0.2,0.6,0c0-0.1,0.1-0.2,0.1-0.2 c3.9-1.3,8.3-0.5,11.8,1.7c3.7,2.3,8.5,7.6,9.8,10.5c0,0,0.1,0,0.1,0l1.6-3.1C98.6,144.3,97.6,141.7,95.6,138.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.5,191.8c-0.3-0.5-0.6-1-0.9-1.5c-4.5,2.3-17.3,7.3-24.4-3.7c-7.8-12,3.9-23.3,6.6-25.7 c-1.4-1.7-2.4-3.7-3.2-5.8c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2-0.2-0.4-0.4-0.5-0.6c0,0-0.1-0.1-0.1-0.1c-1.3-1.5-2.1-3.2-2.4-5.2 c0-0.9-0.1-1.9-0.1-2.8c0.1-1.4,0.5-2.8,1.2-4c0.4-0.9,0.8-1.6,1.4-2.3l1.5-5.3c0,0-6.7,3.7-8.6,10.7 c-1.7,6.2,2.1,14.9,2.1,14.9s-11.9,12.9-5.6,26.2c5.2,10.9,10.5,12.6,17.9,13.2c7.4,0.6,13.9-2.1,13.9-2.1L92.5,191.8 C92.4,191.8,92.5,191.8,92.5,191.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.9,203.5c9.1,1.1,18.4-7.1,18.4-7.1s-2.6,0.2-6,0.4c-4.1,4-11,5.2-15.7-0.5c0,0-0.1-0.1-0.1-0.2 c-0.6-0.1-1.2-0.3-1.8-0.4c-1.8-0.7-3.4-1.7-4.7-3.2c-0.1-0.2-0.3-0.5-0.4-0.7c-0.1,0-0.1,0-0.1,0l-1.3,5.3 C91.2,197.1,95.7,202.6,102.9,203.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.5965,
    y1: 152.508,
    x2: 122.5965,
    y2: 184.2347,
    gradientTransform: "matrix(0.3182 0.948 -0.948 0.3182 225.8906 26.133)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3A5F03"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1933,
    style: {
      stopColor: "#416710"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7036,
    style: {
      stopColor: "#507A2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#568138"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.9,203.5c9.1,1.1,18.4-7.1,18.4-7.1s-2.6,0.2-6,0.4c-4.1,4-11,5.2-15.7-0.5c0,0-0.1-0.1-0.1-0.2 c-0.6-0.1-1.2-0.3-1.8-0.4c-1.8-0.7-3.4-1.7-4.7-3.2c-0.1-0.2-0.3-0.5-0.4-0.7c-0.1,0-0.1,0-0.1,0l-1.3,5.3 C91.2,197.1,95.7,202.6,102.9,203.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4936,
    y1: 99.895,
    x2: 125.8007,
    y2: 99.895,
    gradientTransform: "matrix(0.6448 0.7644 -0.7644 0.6448 116.9827 35.0198)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.5,170.2c0,0,17.1-11.7,5.7-27.5c-11.4-15.8-28.1-2.4-28.1-2.4s-11.9-18.3-27.3-7.1 c-15.4,11.2-3.2,27.3-3.2,27.3s-15.1,11.6-6,26.5c9.9,16.2,28.4,6.5,28.4,6.5s11.9,15.2,27.3,4 C134.7,186.4,122.5,170.2,122.5,170.2z M93.2,189.4c0,0-18,7.5-25.9-4.6c-7.6-11.5,7-24.2,7-24.2s-11.6-15.5,0.5-23.6 c12.4-8.3,23.6,7.8,23.6,7.8s16.9-13.1,26.2-0.2c9.6,13.2-7.1,25.3-7.1,25.3s10.9,16.4-1.3,25.2 C105.4,202.9,93.2,189.4,93.2,189.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.3,196.4c5.1-4.6,7.8-11.3,5.9-18.5c-0.6-2.1-3.6-7.9-3.7-8c0,0,8.4-7.1,8.6-14.5 c-0.6,2-1.1,3.3-1.8,4.8c-0.7,1.3-1.5,2.5-2.5,3.7c-0.1-0.2-0.3-0.4-0.5-0.6c-0.1-0.1-0.3-0.1-0.4,0.1c-0.1,0.2-0.1,0.5,0,0.7 c-0.3-0.1-0.6-0.1-0.8,0.1c-0.5,0.4,0.2,0.8,0.7,0.9c-0.5,0.6-1,1.2-1.5,1.7c-0.1-0.2-0.3-0.4-0.6-0.5c-0.1-0.1-0.4,0-0.3,0.2 c0.1,0.3,0.2,0.6,0.4,0.9c-0.9,1-1.8,1.9-2.7,2.7c0.3,0.5,0.7,1.2,1.1,1.9c-0.3,0-0.6,0.1-0.8,0.4c-0.1,0.1-0.1,0.2,0,0.3 c0.2,0.4,0.9,0.3,1.3,0.2c0.8,1.5,1.7,3.2,2,4.3c0.1,0.4,0.2,0.8,0.3,1.3c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0-0.3,0.1-0.2,0.3 c0.1,0.3,0.2,0.6,0.4,0.9c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.2-0.2,0.4c0.2,0.4,0.8,0.9,1.3,0.7c0.1,0.4,0.1,0.8,0.1,1.1 c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.4,0.2-0.2,0.4c0.3,0.4,0.7,0.6,1.2,0.8c0,0.5,0,1,0,1.4c-0.1,0.5-0.1,1-0.2,1.5 c-0.4-0.2-1.2-0.1-1.4,0.3c-0.1,0.2,0,0.3,0.1,0.4c0.4,0.2,0.7,0.2,1.1,0.1c-0.9,3.8-3,7.3-6,9.8c0,0,0,0-0.1,0 c-0.1-0.2-0.4-0.3-0.6-0.4c-0.2-0.1-0.4,0.1-0.3,0.3c0.1,0.1,0.1,0.2,0.2,0.4c-0.3-0.2-0.6-0.3-0.9-0.3c-0.2,0-0.4,0.3-0.2,0.4 c0.2,0.2,0.4,0.4,0.6,0.6c-0.5,0.3-0.9,0.6-1.4,0.9c-0.1-0.3-0.3-0.7-0.6-0.7c-0.3,0-0.3,0.6-0.3,0.8c0,0.1,0.1,0.2,0.1,0.3 c-0.5,0.3-1.1,0.5-1.7,0.7c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.1-0.4,0-0.4,0.2c-0.1,0.3-0.1,0.6,0.1,0.9c-0.6,0.2-1.2,0.4-1.9,0.5 c-0.1-0.4-0.3-0.9-0.7-0.9c-0.3,0-0.4,0.4-0.4,0.7c-0.3-0.4-0.7-0.6-0.9-0.1c-0.1,0.2-0.1,0.4-0.1,0.6c-2.9,0.4-5.5,0-7.7-0.8 c0.1-0.2,0.1-0.5,0.2-0.7c0-0.1-0.1-0.3-0.3-0.2c-0.2,0.1-0.3,0.2-0.5,0.3c0-0.2,0-0.4,0-0.6c0-0.3-0.4-0.3-0.6-0.1 c-0.7,0.9-1.2-0.2-1.7-0.6c-0.2-0.2-0.4-0.2-0.6-0.3c0.1-0.3,0.1-0.5-0.2-0.7c-0.1-0.1-0.3-0.1-0.4-0.1c0-0.2-0.1-0.4-0.3-0.3 c-0.2,0-0.4,0-0.5,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.1-0.3-0.1-0.4c-0.2-0.1-0.5-0.2-0.7-0.1c0-0.2,0-0.4-0.2-0.5 c-0.3-0.2-0.6,0.1-0.8,0.4c-1-0.7-1.8-1.4-2.5-2c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2 c0-0.4-0.2-0.8-0.6-0.7c-0.5,0-0.6,0.7-0.6,1.1c-1.5,0.5-3.3,1.1-5.1,1.5c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.1-0.3-0.1-0.4,0 c-0.2,0.3-0.3,0.7-0.2,1c-0.5,0.1-1,0.2-1.6,0.3c0-0.3-0.2-0.7-0.4-1c-0.1-0.1-0.3-0.1-0.4,0c-0.2,0.3-0.3,0.5-0.4,0.8 c0-0.4-0.2-0.9-0.6-0.8c-0.4,0.1-0.6,0.8-0.6,1.2c-0.4,0-0.8,0-1.2,0c-0.9,0-1.7-0.1-2.5-0.2c0-0.3-0.1-0.7-0.4-0.8 c-0.2,0-0.5,0.2-0.7,0.4c0.1-0.4,0.1-0.8-0.3-0.9c-0.1,0-0.2,0-0.3,0.1c-0.2,0.3-0.3,0.6-0.5,0.9c-2.4-0.5-4.6-1.5-6.8-3.5 c0.1-0.3,0.3-0.6,0.4-0.9c0.1-0.2-0.2-0.4-0.4-0.3c-0.2,0.1-0.4,0.2-0.6,0.3c0.2-0.3,0.3-0.5,0.3-0.9c0-0.2-0.2-0.3-0.3-0.2 c-0.3,0.2-0.7,0.3-0.9,0.6c-0.2-0.2-0.4-0.5-0.7-0.8c-0.2-0.3-0.4-0.5-0.7-0.9c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.2-0.2-0.4-0.4-0.2 c-0.2,0.2-0.5,0.2-0.8,0.4c-0.6-0.9-1.2-1.9-1.7-3c0.2-0.2,0.4-0.4,0.5-0.6c0.1-0.2,0-0.5-0.3-0.5c-0.2,0-0.4,0-0.7,0.1 c0-0.1,0-0.2,0.1-0.3c0.1-0.3,0.2-0.5,0.1-0.8c-0.1-0.5-0.5-0.8-0.9-1c0.3-0.2,0.7-0.4,0.5-0.8c-0.1-0.2-0.5-0.5-0.8-0.6 c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.1-0.3,0-0.4c-0.2-0.1-0.5-0.2-0.7-0.3c0.3-0.2,0.9-0.5,0.7-1c-0.1-0.3-0.4-0.4-0.7-0.4 c0.3-0.1,0.7-0.2,0.7-0.4c0-0.3-0.6-0.4-0.9-0.5c0-0.8,0.1-1.6,0.3-2.4c0.1-0.4,0.2-0.7,0.3-1.1c0.5,0,0.9-0.3,1.1-0.7 c0.1-0.4,0-0.7-0.2-1c0.1,0,0.3,0.1,0.4,0.1c0.3,0.1,0.6-0.3,0.4-0.5c-0.2-0.2-0.4-0.5-0.3-0.8c0-0.3,0.1-0.3,0.4-0.5 c0.3-0.2,0.5-0.3,0.7-0.6c0.3-0.4,0.3-0.8,0.1-1.3c0,0,0,0,0,0c0.3,0,0.8-0.1,0.9-0.4c0.1-0.2,0-0.5-0.2-0.7 c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.3-0.2,0.2-0.3c-0.1-0.2-0.2-0.5-0.4-0.7c0.9-1.4,1.8-2.7,2.6-3.7c0.4,0.1,0.8,0.1,1.1-0.2 c0.2-0.2,0.2-0.4,0.1-0.6c0.3,0.1,0.6,0.1,0.8-0.2c0.2-0.4-0.1-0.6-0.4-0.8c0.3-0.2,0.5-0.4,0.4-0.8c-0.1-0.2-0.2-0.3-0.4-0.3 c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.2,0-0.4-0.2-0.4c-0.3,0-0.6-0.1-0.9,0c-0.5-1-1-2-1.3-3.1 c0.3-0.3,0.8-0.6,0.4-1.1c-0.2-0.3-0.6-0.2-0.9-0.1c0,0,0-0.1,0-0.1c0.2-0.2,0.3-0.4,0.4-0.7c0-0.1,0-0.2-0.1-0.3 c-0.2-0.1-0.4-0.2-0.6-0.2c0,0,0,0,0,0c0.3-0.1,0.5-0.2,0.8-0.4c0.2-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.5-0.2-0.8-0.3 c0.4-0.3,0.8-0.7,0.6-1.2c-0.1-0.3-0.4-0.4-0.7-0.5c0.1-0.2,0.2-0.3,0.1-0.6c0-0.1-0.1-0.3-0.3-0.3c0.2-0.1,0.4-0.1,0.5-0.2 c0.2-0.1,0.3-0.4,0-0.5c-0.2-0.1-0.3-0.2-0.5-0.2c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.4-0.2c0-0.9,0-1.9,0.2-2.9 c0.4-0.1,0.9-0.2,1.2-0.4c0.2-0.1,0.3-0.5,0.1-0.6c-0.2-0.1-0.4-0.2-0.5-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.1-0.4,0-0.5 c-0.2-0.1-0.4-0.3-0.6-0.3c1.4-5,4-7.2,9.3-11.5c-5.5,2.6-9.2,6.3-10.7,12.3c-1.4,5.7,0.3,12.1,3.5,16.9 c-6.5,6.6-11,14.4-7.3,23.2c3.4,8.2,7.7,11.1,12.3,12.4c7.5,2.1,14.2-0.2,17.9-1.9c0,0,3.9,3.8,8.5,6.1c1.9,1,4.8,1.5,6.7,1.5 c2.4,0.1,4.9-0.4,7.1-1.1C116.7,199.8,119.2,198.3,121.3,196.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68,141.4c0.1-0.1,0.2-0.2,0.1-0.4c-0.3-0.3-0.6-0.6-1-0.7c-0.2,0-0.2,0.2-0.1,0.3c0,0,0.1,0.1,0.1,0.1 c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.1,0.3,0,0.3c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0c-0.4,0.1-0.3,0.6,0.1,0.6 c0.1,0,0.3,0,0.4-0.1C67.5,141.6,67.8,141.5,68,141.4z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M121.2,141.1c-6.6-5.1-17-1.4-22.9,3.1c-2.8-4-7.3-8-12-9c4.5,2.4,9.7,7.1,11.8,10.2 C104.1,140.8,113.9,137.3,121.2,141.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.3,287.7c0,0,5.7-8.5,0.8-14.9c-1.9-2.5-7-8-12.4-1.4c-5.4,6.5-7.9,11.2-7.9,11.2l-1.4-1.7 c0,0,0.2-10.6,7.2-14.1c7-3.5,13.9-8.3,17.6,1C163.9,277,166.9,282.9,156.3,287.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.8,268.8c0,0-7.9-2.1-11.9,0.4c-3.9,2.5-8.5,7.2-5.5,11.8c2.6,4,6.5,7,6.5,7s-11.2-1.7-11.5-9.7 c-0.3-8,5.5-15.7,11.7-14.6C123.2,264.8,127.8,268.8,127.8,268.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121,288.1l1.3,2.9c0,0-4.4,9.4-4,13.7c0.3,2.9,1.8,4.4,6.7,4.9c4.9,0.5,15.7-2.8,15.7-2.8s-4.3,7.8-11,7.5 c-6.7-0.3-16,0-16.4-5.9C112.9,302.4,121,288.1,121,288.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.8,282.9c0,0-1.1,5.4-6.4,10.1c-3.3,3-13.1,5-13.1,5s-0.1,9.2-2.2,11.9c-3.9,4.9-8.5,5.6-8.5,5.6 s8.2-10.1,6.5-16.3c-1.7-6.2-1.7-6.2-1.7-6.2L165.8,282.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9409,
    y1: 235.1333,
    x2: 117.7216,
    y2: 319.0136,
    gradientTransform: "matrix(0.7261 0.6876 -0.6876 0.7261 237.6512 -15.6823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M119,260.9c7.5-0.1,16,12,16,12s7.6-11.5,17.1-12.6c8.2-0.9,17.4,12.9,13.3,23.8 c-4.1,10.9-21.6,11.1-21.6,11.1c0.9,6.5,1.2,13.2-2.5,16.8c-5.2,5-14.8,6.1-23.5,2.7c-14.9-5.7-2.5-22.8-2.5-22.8 s-9.9-5.9-12.1-13.2C101,271.5,111.5,261.1,119,260.9z M105.3,278.3c0.8,7.2,12.3,11.7,12.3,11.7s-7.5,14.6-4.3,18.3 c3.1,3.8,12.1,8.3,20.9,5.3c8.8-3,7.8-7.8,7.4-12.8c-0.4-5-1.3-7.7-1.3-7.7s9.3-0.2,16.9-4.4c7.6-4.2,7.9-12.3,5.2-17.9 c-3.3-6.7-10.8-9.4-16.3-6.3c-8.9,5.1-10.8,12.2-10.8,12.2s-9.4-14.7-18.3-13C111.1,264.8,104.5,271.1,105.3,278.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.6211,
    y1: 233.731,
    x2: 117.5341,
    y2: 319.421,
    gradientTransform: "matrix(0.7261 0.6876 -0.6876 0.7261 237.6512 -15.6823)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M117,263.7c8.8-1.7,18.3,13,18.3,13s1.9-7.1,10.8-12.2c5.5-3.1,13-0.4,16.3,6.3c2.8,5.6,2.5,13.6-5.2,17.9 c-7.6,4.2-16.9,4.4-16.9,4.4s0.9,2.7,1.3,7.7c0.4,5,1.5,9.8-7.4,12.8c-8.8,3-17.8-1.6-20.9-5.3c-3.1-3.8,4.3-18.3,4.3-18.3 s-11.5-4.5-12.3-11.7C104.5,271.1,111.1,264.8,117,263.7z M107.8,279.4c2.7,5.5,13.2,8.7,13.2,8.7s-9,19.8-3,22.2 c6,2.3,22.4,2.8,21.7-5.9c-0.7-8.7-1.9-13.2-1.9-13.2s17.7-1.4,21.3-7.6c2-3.5,3.1-9.7-1.2-13.7c-4.3-4-9.1-5.3-14.5-0.4 c-5.4,4.9-8,11.4-8,11.4s-8.6-12.2-14.5-14.6C115.1,263.9,105,273.8,107.8,279.4z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 105.3,
    y: 263.2,
    width: 58.7,
    height: 51.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 105.3,
    y: 263.2,
    width: 58.7,
    height: 51.4,
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 105.3,
    y: 263.2,
    width: 58.7,
    height: 51.4
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 105.3,
    y: 263.2,
    width: 58.7,
    height: 51.4,
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_7_",
    cx: 127.5413,
    cy: 289.8477,
    r: 28.4355,
    gradientTransform: "matrix(0.7261 0.6876 -0.6876 0.7261 237.6512 -15.6823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1135,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4623,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117,263.7c8.8-1.7,18.3,13,18.3,13s1.9-7.1,10.8-12.2c5.5-3.1,13-0.4,16.3,6.3 c2.8,5.6,2.5,13.6-5.2,17.9c-7.6,4.2-16.9,4.4-16.9,4.4s0.9,2.7,1.3,7.7c0.4,5,1.5,9.8-7.4,12.8c-8.8,3-17.8-1.6-20.9-5.3 c-3.1-3.8,4.3-18.3,4.3-18.3s-11.5-4.5-12.3-11.7C104.5,271.1,111.1,264.8,117,263.7z M107.8,279.4c2.7,5.5,13.2,8.7,13.2,8.7 s-9,19.8-3,22.2c6,2.3,22.4,2.8,21.7-5.9c-0.7-8.7-1.9-13.2-1.9-13.2s17.7-1.4,21.3-7.6c2-3.5,3.1-9.7-1.2-13.7 c-4.3-4-9.1-5.3-14.5-0.4c-5.4,4.9-8,11.4-8,11.4s-8.6-12.2-14.5-14.6C115.1,263.9,105,273.8,107.8,279.4z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 127.5413,
    cy: 289.8477,
    r: 28.4355,
    gradientTransform: "matrix(0.7261 0.6876 -0.6876 0.7261 237.6512 -15.6823)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4DB49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3387,
    style: {
      stopColor: "#ADD644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8161,
    style: {
      stopColor: "#9BC635"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BF2E"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M117,263.7c8.8-1.7,18.3,13,18.3,13s1.9-7.1,10.8-12.2c5.5-3.1,13-0.4,16.3,6.3c2.8,5.6,2.5,13.6-5.2,17.9 c-7.6,4.2-16.9,4.4-16.9,4.4s0.9,2.7,1.3,7.7c0.4,5,1.5,9.8-7.4,12.8c-8.8,3-17.8-1.6-20.9-5.3c-3.1-3.8,4.3-18.3,4.3-18.3 s-11.5-4.5-12.3-11.7C104.5,271.1,111.1,264.8,117,263.7z M107.8,279.4c2.7,5.5,13.2,8.7,13.2,8.7s-9,19.8-3,22.2 c6,2.3,22.4,2.8,21.7-5.9c-0.7-8.7-1.9-13.2-1.9-13.2s17.7-1.4,21.3-7.6c2-3.5,3.1-9.7-1.2-13.7c-4.3-4-9.1-5.3-14.5-0.4 c-5.4,4.9-8,11.4-8,11.4s-8.6-12.2-14.5-14.6C115.1,263.9,105,273.8,107.8,279.4z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M120,260.5c3.1,0.3,5.9,1.9,8.3,4c2.7,2.3,5.2,5.3,6.9,8c3.6-6.9,12.9-13,18.5-12.1 c-4.4,0.2-14.5,6-18.4,13.3c-0.8-1.5-4-5.5-6.4-7.7c-2.3-2-4.9-4-8-4.4c-6.9-1-13.1,4.6-16.5,10.1 C107.1,266.2,112.9,259.9,120,260.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M116.8,301.9c-0.5,2.8-1.5,5.8,0.9,7.7c2.1,1.6,6.1,2,8.6,1.8c4.6-0.2,11.8-0.3,12.7-5.8 c0.7-4.6-0.7-9.9-1.3-14.4c0.7,2.9,1.6,6.2,2,9.2c0.3,2.2,0.6,4.8-0.4,6.9c-2.2,4.9-9.9,5.1-14.6,5c-4.7-0.1-9.1-0.9-9.2-6.3 c-0.1-5.7,2.6-13,5.3-17.9C121,289.1,117.6,297.2,116.8,301.9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M145.7,266.2c0.2,0.2,0.5,0.4,0.6,0.6c0.1,0.2,0,0.3-0.2,0.4c-0.6,0.1-1-0.6-1.1-1.1 C145.1,265.9,145.3,265.6,145.7,266.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.6,307.5c0.2,0.2,0.5,0.4,0.6,0.6c0.1,0.2,0,0.3-0.2,0.4c-0.6,0.1-1-0.6-1.1-1.1 C113.9,307.3,114.1,307,114.6,307.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M107.7,280.6c0.2,0.2,0.5,0.4,0.6,0.6c0.1,0.2,0,0.3-0.2,0.4c-0.6,0.1-1-0.6-1.1-1.1 C107.1,280.4,107.2,280.1,107.7,280.6z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M147.1,266.3c0,0.2-0.3,0.4-0.4,0.3c-0.4-0.3-0.2-0.9,0.1-1.2C146.9,265.3,147.1,265.2,147.1,266.3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M106.9,279.3c0,0.2-0.3,0.4-0.4,0.3c-0.4-0.3-0.2-0.9,0.1-1.2C106.8,278.3,107,278.2,106.9,279.3z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.3,264.7c0.1,0.3,0,0.6-0.2,0.9c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.3,0-0.5,0.1-0.7 C148,264.7,148.2,264.5,148.3,264.7z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M114.1,305.6c0.1,0.3,0,0.6-0.2,0.9c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.3,0-0.5,0.1-0.7 C113.8,305.6,114,305.4,114.1,305.6z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M139.4,292.2c0.2,0.2,0.3,0.6,0.2,0.9c0,0.1-0.2,0.1-0.3,0.1c-0.2-0.2-0.2-0.4-0.2-0.7 C139.2,292.3,139.3,292,139.4,292.2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M140.1,291.9c0.3,0,0.6,0,0.8,0.2c0.1,0.1,0,0.2-0.1,0.3c-0.3,0.1-0.5,0-0.7-0.2 C140.1,292.2,139.9,291.9,140.1,291.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M244.6,77.5c0,0,1.9-11.1,10.6-12.5c3.4-0.6,11.6-1.1,11,8.2s-2.2,14.8-2.2,14.8l2.4-0.3 c0,0,7.9-8.6,4.9-16.6s-4.8-17.2-14.7-12.5C246.7,63.2,239.8,65.7,244.6,77.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.6,84c0,0,7.9,4.3,9.2,9.2c1.2,5,1.3,12.2-4.5,13.6c-5.1,1.2-10.4,0.7-10.4,0.7s10.2,7.1,16.5,1 c6.3-6.1,7.5-16.7,1.8-20.5C288.3,84.3,281.6,84,281.6,84z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.5,104.5l-3.2,1.3c0,0-3.5,10.8-7.1,14c-2.4,2.1-4.8,2.1-9-1.2c-4.2-3.3-10.4-14.1-10.4-14.1 s-2.4,9.5,3.1,14.3c5.6,4.8,12.8,12.1,17.6,7.7C268.1,122,272.5,104.5,272.5,104.5z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.7,66.5c0,0-3.2,5.1-2.5,12.9c0.4,4.9,6.6,13.9,6.6,13.9s-6.9,7.4-7.2,11.2c-0.6,6.8,2.6,10.9,2.6,10.9 s1.1-14.3,7.2-17.9c6-3.6,6-3.6,6-3.6L240.7,66.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.4688,
    y1: 37.4863,
    x2: 248.8627,
    y2: 128.4299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M294.6,84.4c-5.9-5.8-21.8-2.5-21.8-2.5s2.7-14.9-4.1-22.9c-5.8-6.9-23.6-2.9-28.6,8.9 c-5,11.8,8.9,25.2,8.9,25.2c-5.7,4.5-10.9,9.6-10.7,15.3c0.3,7.9,7.2,16,16.7,19.9c16.2,6.7,19.2-16.3,19.2-16.3 s12.3,2.7,19.6-1.4C300.9,106.4,300.5,90.1,294.6,84.4z M292.4,108.5c-6,5.1-18.6,0-18.6,0s-5,17.2-10.4,17.9 s-15.9-2.5-20.7-11.5c-4.8-9.1-0.3-12.1,3.8-15.8c4.1-3.7,6.9-5.1,6.9-5.1s-7.2-7.2-10.1-16.3c-2.9-9.1,3-15.8,9.4-18.1 c7.7-2.8,15.7,0.6,17.7,7.3c3.2,10.8-0.6,17.9-0.6,17.9s18.6-4.6,24.4,3.4C297.9,93.4,298.4,103.4,292.4,108.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.7408,
    y1: 37.6168,
    x2: 249.1348,
    y2: 128.5603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M294.1,88.1c-5.8-8-24.4-3.4-24.4-3.4s3.9-7.1,0.6-17.9c-2-6.6-10-10.1-17.7-7.3c-6.4,2.4-12.2,9-9.4,18.1 c2.9,9.1,10.1,16.3,10.1,16.3s-2.7,1.4-6.9,5.1c-4.1,3.7-8.6,6.7-3.8,15.8c4.8,9.1,15.3,12.2,20.7,11.5s10.4-17.9,10.4-17.9 s12.6,5.1,18.6,0C298.4,103.4,297.9,93.4,294.1,88.1z M289.6,107.5c-6.4,2.3-17.1-3.1-17.1-3.1s-7.8,22.6-14.4,19.9 c-6.6-2.7-19.9-14.6-12.9-21.1c7.1-6.4,11.5-9.1,11.5-9.1S243.7,79.6,245.5,72c1-4.3,4.8-10,11.3-10c6.5,0,11.2,2.6,11.9,10.7 c0.6,8-2.2,15.1-2.2,15.1s16.1-3.3,22.5-0.7C295.4,89.6,296,105.2,289.6,107.5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 240.6,
    y: 58.5,
    width: 56.3,
    height: 68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 240.6,
    y: 58.5,
    width: 56.3,
    height: 68,
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 240.6,
    y: 58.5,
    width: 56.3,
    height: 68
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 240.6,
    y: 58.5,
    width: 56.3,
    height: 68,
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_12_",
    cx: 268.7686,
    cy: 92.4957,
    r: 31.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1135,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4623,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M294.1,88.1c-5.8-8-24.4-3.4-24.4-3.4s3.9-7.1,0.6-17.9c-2-6.6-10-10.1-17.7-7.3 c-6.4,2.4-12.2,9-9.4,18.1c2.9,9.1,10.1,16.3,10.1,16.3s-2.7,1.4-6.9,5.1c-4.1,3.7-8.6,6.7-3.8,15.8 c4.8,9.1,15.3,12.2,20.7,11.5s10.4-17.9,10.4-17.9s12.6,5.1,18.6,0C298.4,103.4,297.9,93.4,294.1,88.1z M289.6,107.5 c-6.4,2.3-17.1-3.1-17.1-3.1s-7.8,22.6-14.4,19.9c-6.6-2.7-19.9-14.6-12.9-21.1c7.1-6.4,11.5-9.1,11.5-9.1 S243.7,79.6,245.5,72c1-4.3,4.8-10,11.3-10c6.5,0,11.2,2.6,11.9,10.7c0.6,8-2.2,15.1-2.2,15.1s16.1-3.3,22.5-0.7 C295.4,89.6,296,105.2,289.6,107.5z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_13_",
    cx: 268.7686,
    cy: 92.4957,
    r: 31.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4DB49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3387,
    style: {
      stopColor: "#ADD644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8161,
    style: {
      stopColor: "#9BC635"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BF2E"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M294.1,88.1c-5.8-8-24.4-3.4-24.4-3.4s3.9-7.1,0.6-17.9c-2-6.6-10-10.1-17.7-7.3c-6.4,2.4-12.2,9-9.4,18.1 c2.9,9.1,10.1,16.3,10.1,16.3s-2.7,1.4-6.9,5.1c-4.1,3.7-8.6,6.7-3.8,15.8c4.8,9.1,15.3,12.2,20.7,11.5s10.4-17.9,10.4-17.9 s12.6,5.1,18.6,0C298.4,103.4,297.9,93.4,294.1,88.1z M289.6,107.5c-6.4,2.3-17.1-3.1-17.1-3.1s-7.8,22.6-14.4,19.9 c-6.6-2.7-19.9-14.6-12.9-21.1c7.1-6.4,11.5-9.1,11.5-9.1S243.7,79.6,245.5,72c1-4.3,4.8-10,11.3-10c6.5,0,11.2,2.6,11.9,10.7 c0.6,8-2.2,15.1-2.2,15.1s16.1-3.3,22.5-0.7C295.4,89.6,296,105.2,289.6,107.5z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.1,83.3c-2.7-2.2-6.2-2.9-9.6-3.1c-3.9-0.2-8.2,0.3-11.6,1.1c2.4-8.2-0.5-20.2-5.6-23.6 c3.4,3.5,7,15.7,4.6,24.5c1.8-0.5,7.4-1.4,10.9-1.3c3.4,0.1,6.9,0.5,9.7,2.5c6.3,4.4,7,13.6,5.6,20.5 C300.1,97.5,300.2,88.2,294.1,83.3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.4,118.7c-1.7,2.6-3.2,5.7-6.6,5.4c-2.9-0.3-6.3-3-8.3-5.1c-3.5-3.6-9.2-9.2-5.7-14.3 c2.9-4.2,8-7.4,11.9-10.6c-2.8,1.8-5.9,3.8-8.6,5.8c-1.9,1.5-4.1,3.4-4.9,5.8c-1.9,5.6,4,11.6,7.8,15c3.9,3.5,7.9,6.2,12.1,2 c4.4-4.5,7.7-12.3,9.3-18.3C271.7,105.3,268.3,114.3,265.4,118.7z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.3,68.4c-0.3,0-0.7-0.1-1,0c-0.2,0.1-0.2,0.3-0.1,0.4c0.4,0.5,1.3,0.2,1.7-0.1 C270,68.6,270.1,68.2,269.3,68.4z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M262.9,124.8c-0.3,0-0.7-0.1-1,0c-0.2,0.1-0.2,0.3-0.1,0.4c0.4,0.5,1.3,0.2,1.7-0.1 C263.6,125.1,263.7,124.7,262.9,124.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M288.8,108.6c-0.3,0-0.7-0.1-1,0c-0.2,0.1-0.2,0.3-0.1,0.4c0.4,0.5,1.3,0.2,1.7-0.1 C289.4,108.9,289.5,108.5,288.8,108.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.2,67.4c-0.2,0.2-0.1,0.6,0.1,0.6c0.5,0,0.8-0.5,0.8-1C269,66.8,268.9,66.6,268.2,67.4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M290.3,108.1c-0.2,0.2-0.1,0.6,0.1,0.6c0.5,0,0.8-0.5,0.8-1C291.2,107.5,291.1,107.2,290.3,108.1z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.4,65.2c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.2,0.2,0.2,0.3,0.2c0.3-0.1,0.4-0.4,0.4-0.7 C268.6,65.4,268.6,65.1,268.4,65.2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M264.7,123.7c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.2,0.2,0.2,0.3,0.2c0.3-0.1,0.4-0.4,0.4-0.7 C265,123.9,265,123.5,264.7,123.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.7,93.8c-0.3,0-0.6,0.2-0.8,0.5c-0.1,0.1,0.1,0.3,0.2,0.3c0.3,0,0.5-0.2,0.7-0.4 C254.8,94.1,255,93.8,254.7,93.8z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M254.4,93.1c-0.2-0.3-0.5-0.4-0.9-0.4c-0.2,0-0.2,0.2-0.1,0.3c0.1,0.3,0.4,0.4,0.7,0.4 C254.2,93.3,254.5,93.3,254.4,93.1z"
  }))), /*#__PURE__*/React.createElement("g", null, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.5,241.8c0,0,1.4-4.9,6.5-7.5c5.6-2.9,7.9-0.5,9.8,1.3c3.2,2.9,7.3,8.5,7.3,8.5s3.2-5,6.5-8.1 c4.6-4.3,11.9-7.4,15-5.4s4.5,5.7,4.5,5.7s3.2-7.8-4.5-9.5s-13.8,3.9-13.8,3.9l-6.9,7.5c0,0-2.6-6.1-7.8-7.4 c-5.2-1.3-9.3-2.4-12.8,1.4C226.9,236,226.5,241.8,226.5,241.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222,267.4c0,0-0.1,3.5,0.2,4.8c0.7,2.7,5.6,6.7,12.4,5.8c9.3-1.2,15-7.4,15-7.4s5.2,6.7,14,6.7 c11.3,0,15.7-7.8,16.4-11.9c0.9-5.8-1.3-6.9-1.3-6.9s-1.6,11.8-10.1,14.5c-5.9,1.9-18.1-6.6-18.1-6.6s-7.3,6.5-13.4,6.6 C231,273.3,222,267.4,222,267.4z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223,239c0,0-1.2,7.7,1.7,11.7c2.8,4,4.6,5.3,4.6,5.3l2.9-2.6L223,239z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.4,232.6c0,0,0.9,6.1-2.6,10.4c-3.6,4.2-7.5,6.5-7.5,6.5l-1.9-2.1c0,0,6.6-4.9,8.4-8.5 C277.7,235.4,279.4,232.6,279.4,232.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.5711,
    y1: 197.0574,
    x2: 236.7462,
    y2: 282.2007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M269.3,247.4c0,0,18.7-13.7,5.2-21.7c-13.5-8-23.3,9.8-23.3,9.8s-9-13.5-22.4-4.3c-13.4,9.2,0,22,0,22 s-13.2,13.8-2.8,20.8c10.4,7,24-5.8,24-5.8s11.4,13.9,25.4,2.4C289.4,259.1,269.3,247.4,269.3,247.4z M276.1,264.8 c-3,6.3-8.8,8.2-13.9,8.2c-5.2,0-12.2-7.8-12.2-7.8s-8.4,10.2-18.9,8.1c-6.9-1.4-7.8-6.1-6.1-10.8c1.9-5.2,7.3-9.1,7.3-9.1 s-1.7-1.9-3.3-4c-1.7-2.1-4-5.6-3-10.9c0.6-3.2,3.9-7.6,10.5-8.8c8.3-1.6,14.6,8.5,14.6,8.5s5.3-7,6.2-7.8 c5.7-5.2,10.6-5.8,15.6-3.7c5,2.2,4.5,5.8,2.9,11.2c-1.6,5.3-9.7,10.7-9.7,10.7s6.2,3.5,8.6,6.4 C276.7,257.5,278.3,260.3,276.1,264.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.1454,
    y1: 196.8533,
    x2: 236.3205,
    y2: 281.9967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B9913"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#527000"
    }
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M274.6,255c-2.4-2.9-8.6-6.4-8.6-6.4s8.1-5.4,9.7-10.7c1.6-5.3,2.1-9-2.9-11.2c-5-2.2-9.9-1.5-15.6,3.7 c-0.9,0.8-6.2,7.8-6.2,7.8s-6.2-10.1-14.6-8.5c-6.6,1.3-9.8,5.6-10.5,8.8c-1,5.2,1.3,8.8,3,10.9c1.7,2.1,3.3,4,3.3,4 s-5.4,3.9-7.3,9.1c-1.7,4.7-0.9,9.4,6.1,10.8c10.5,2.2,18.9-8.1,18.9-8.1s7.1,7.9,12.2,7.8c5.2,0,10.9-1.9,13.9-8.2 C278.3,260.3,276.7,257.5,274.6,255z M263.5,270.6c-6.9-0.4-13.5-7.9-13.5-7.9s-7.6,8.4-15,8.4c-7.4-0.1-10.2-3.4-7.4-8.4 c2.8-4.9,6.8-9.3,6.8-9.3s-12.6-11.6-4.3-18.6c9.3-7.8,13.7-2,16,0.3c2.3,2.3,4.5,5.8,4.5,5.8s10.3-15.5,19.4-12.9 s2.8,12.5-1.3,15.5c-4.1,3-5.8,5-5.8,5s9,5.9,11.1,10C276,262.8,270.4,271,263.5,270.6z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 224.2,
    y: 225.5,
    width: 52.9,
    height: 48.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 224.2,
    y: 225.5,
    width: 52.9,
    height: 48.1,
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 224.2,
    y: 225.5,
    width: 52.9,
    height: 48.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 224.2,
    y: 225.5,
    width: 52.9,
    height: 48.1,
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_17_",
    cx: 250.6756,
    cy: 249.5431,
    r: 25.2826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1135,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4623,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6719,
    style: {
      stopColor: "#9D9D9D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8964,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4D4D4D"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M274.6,255c-2.4-2.9-8.6-6.4-8.6-6.4s8.1-5.4,9.7-10.7c1.6-5.3,2.1-9-2.9-11.2c-5-2.2-9.9-1.5-15.6,3.7 c-0.9,0.8-6.2,7.8-6.2,7.8s-6.2-10.1-14.6-8.5c-6.6,1.3-9.8,5.6-10.5,8.8c-1,5.2,1.3,8.8,3,10.9c1.7,2.1,3.3,4,3.3,4 s-5.4,3.9-7.3,9.1c-1.7,4.7-0.9,9.4,6.1,10.8c10.5,2.2,18.9-8.1,18.9-8.1s7.1,7.9,12.2,7.8c5.2,0,10.9-1.9,13.9-8.2 C278.3,260.3,276.7,257.5,274.6,255z M263.5,270.6c-6.9-0.4-13.5-7.9-13.5-7.9s-7.6,8.4-15,8.4c-7.4-0.1-10.2-3.4-7.4-8.4 c2.8-4.9,6.8-9.3,6.8-9.3s-12.6-11.6-4.3-18.6c9.3-7.8,13.7-2,16,0.3c2.3,2.3,4.5,5.8,4.5,5.8s10.3-15.5,19.4-12.9 s2.8,12.5-1.3,15.5c-4.1,3-5.8,5-5.8,5s9,5.9,11.1,10C276,262.8,270.4,271,263.5,270.6z"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 250.6756,
    cy: 249.5431,
    r: 25.2826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4DB49"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3387,
    style: {
      stopColor: "#ADD644"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8161,
    style: {
      stopColor: "#9BC635"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#92BF2E"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M274.6,255c-2.4-2.9-8.6-6.4-8.6-6.4s8.1-5.4,9.7-10.7c1.6-5.3,2.1-9-2.9-11.2c-5-2.2-9.9-1.5-15.6,3.7 c-0.9,0.8-6.2,7.8-6.2,7.8s-6.2-10.1-14.6-8.5c-6.6,1.3-9.8,5.6-10.5,8.8c-1,5.2,1.3,8.8,3,10.9c1.7,2.1,3.3,4,3.3,4 s-5.4,3.9-7.3,9.1c-1.7,4.7-0.9,9.4,6.1,10.8c10.5,2.2,18.9-8.1,18.9-8.1s7.1,7.9,12.2,7.8c5.2,0,10.9-1.9,13.9-8.2 C278.3,260.3,276.7,257.5,274.6,255z M263.5,270.6c-6.9-0.4-13.5-7.9-13.5-7.9s-7.6,8.4-15,8.4c-7.4-0.1-10.2-3.4-7.4-8.4 c2.8-4.9,6.8-9.3,6.8-9.3s-12.6-11.6-4.3-18.6c9.3-7.8,13.7-2,16,0.3c2.3,2.3,4.5,5.8,4.5,5.8s10.3-15.5,19.4-12.9 s2.8,12.5-1.3,15.5c-4.1,3-5.8,5-5.8,5s9,5.9,11.1,10C276,262.8,270.4,271,263.5,270.6z"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.1,232.3c-0.4-2.9-2.6-4.7-5.4-4.9c-4.3-0.4-7.8,1.5-11.2,4.4c-3,2.5-5.8,6-8,8.8c0,0-3.7-5.6-7.1-8.2 c-4-3.1-8-1.6-10.1,0.2c2.5-1.3,4.8-1.9,6.1-1.5c2.4,0.6,3,1,4.6,2.5c2.5,2.4,4.6,5.1,6.5,7.9c1.2-1.5,7.9-10.6,14.1-12.8 c3.3-1.2,7.8-0.9,9.3,2.9c1.3,3.2-0.3,5.7-2.5,9.3C273.8,238.7,275.5,235.6,275.1,232.3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M278,268c-3.7,3.9-8.8,7.1-14.3,6.9c-2.8-0.1-5.5-0.9-7.9-2.2c-2.3-1.2-5-4-6-5.3c-4.8,5.4-11.7,9.4-18.5,8 c-3-0.6-6.4-2.7-8.7-5.5c2.3,4.6,7.8,6.9,12.7,6.4c5.6-0.6,10.7-3.8,14.5-7.9c3.5,4.8,9.1,7.1,14,7.3 C269.3,276,273.1,273.9,278,268z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M231.6,255.1c-0.4-0.1-1.3,0-1.5,0.5c0,0.1,0,0.2,0.1,0.2c0.3,0.1,0.4,0,0.7-0.1c0.3-0.1,0.5-0.2,0.8-0.3 C231.8,255.3,231.7,255.1,231.6,255.1z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M231,256.2c-0.4,0-0.7,0.2-1,0.5c-0.1,0.1,0,0.2,0.1,0.1c0.3-0.2,0.7-0.3,0.9-0.6 C231.1,256.3,231.1,256.2,231,256.2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M236.1,272.4c-0.2-0.2-0.5-0.4-0.8-0.6c-0.1,0-0.2,0-0.2,0.1c-0.1,0.5,0.4,0.9,0.8,0.9 C236.2,272.8,236.3,272.5,236.1,272.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M237.2,271.7c0,0.2,0,0.3,0,0.5c0,0.2,0.4,0.3,0.5,0.1c0.1-0.1,0.1-0.2,0.1-0.4 C237.9,271.4,237.2,271.2,237.2,271.7z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.3,271.6c0,0.2,0,0.3,0,0.5c0,0.2,0.4,0.3,0.5,0.1c0.1-0.1,0.1-0.2,0.1-0.4 C266.1,271.4,265.4,271.2,265.3,271.6z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M250.1,263.7c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2,0.2,0.4,0.3,0.3c0.2-0.1,0.3-0.2,0.3-0.5 C250.5,263.8,250.3,263.6,250.1,263.7z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M267.5,270.7c-0.2,0.1-0.3,0.2-0.4,0.4c-0.1,0.2,0.2,0.4,0.3,0.3c0.2-0.1,0.3-0.2,0.3-0.5 C267.8,270.8,267.6,270.6,267.5,270.7z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.6,241.3c-0.4,0-0.7,0.2-1,0.4c-0.1,0.1,0,0.2,0.1,0.2c0.4,0.1,1-0.1,1.1-0.6 C272.7,241.4,272.7,241.3,272.6,241.3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M271.2,242.9c-0.1-0.2-0.2-0.3-0.4-0.3c-0.1,0-0.2,0.1-0.1,0.1c0.1,0.2,0.1,0.3,0.3,0.4 C271.1,243.3,271.3,243.1,271.2,242.9z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M265.4,247c-0.2,0-0.4,0-0.6,0.2c0,0,0,0.1,0,0.1c0.2,0.2,0.3,0.2,0.6,0.2C265.7,247.5,265.7,247,265.4,247z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M276,259.1c-0.4,0-0.7,0.4-0.9,0.7c-0.1,0.1,0,0.3,0.2,0.3c0.4,0,0.9-0.4,0.9-0.8 C276.2,259.1,276.1,259.1,276,259.1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M276.1,260.8c-0.3-0.1-0.7-0.2-1,0.1c-0.1,0.1-0.1,0.3,0,0.4c0.3,0.2,0.7,0.1,1,0.1 C276.4,261.2,276.4,260.9,276.1,260.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepper);
export default __webpack_public_path__ + "static/media/pepper.e9d53fa11a7df96cf928b1df4a9585a7.svg";
export { ForwardRef as ReactComponent };